// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"rU","link":"rV","linkText":"rW","linkIcon":"rX","isRental":"rY","active":"rZ","synopsisAndButton":"r0","linkWrapper":"r1"};